import React from "react";


import "./LeaderBoard.css";


function PrizeRule() {

  return (
    <>
      <div>
        <div className="leftContainer" style={{ height: "100vh" }}>
          <section className="refer_page_main_section">
            <div className="refer_page_top_main_box_outer mb-5">
              <div className="refer_page_top_main_box">
                <h2>1 January - 28 February Competition</h2>
              </div>
            </div>

            <div className="refer_page_top_main_box_outer container-table">
              <table class="leaderboard-table">
                <thead>
                  <tr>
                   
                    <th>Bouns Prize</th>
                    <th>Rank</th>
                    {/*<th className="border-rad1">MATCHES</th>*/}
                  </tr>
                </thead>
                <tbody>
                <tr>
                  <td>500000</td>
                  <td>1</td>
                </tr>
                <tr>
                  <td>400000</td>
                  <td>2</td>
                </tr>
                <tr>
                  <td>300000</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>200000</td>
                  <td>4</td>
                </tr>
                <tr>
                  <td>100000</td>
                  <td>5</td>
                </tr>
                <tr>
                  <td>50000</td>
                  <td>6</td>
                </tr>
                <tr>
                  <td>40000</td>
                  <td>7</td>
                </tr>
                <tr>
                  <td>30000</td>
                  <td>8</td>
                </tr>
                <tr>
                  <td>20000</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td>10000</td>
                  <td>10</td>
                </tr>
                <tr>
                  <td>5000</td>
                  <td>11</td>
                </tr>
                <tr>
                  <td>3000</td>
                  <td>12</td>
                </tr>
                <tr>
                  <td>2000</td>
                  <td>13</td>
                </tr>
                <tr>
                  <td>1000</td>
                  <td>14</td>
                </tr>
                <tr>
                  <td>1000</td>
                  <td>15</td>
                </tr>
                <tr>
                  <td>600</td>
                  <td>16</td>
                </tr>
                <tr>
                  <td>500</td>
                  <td>17</td>
                </tr>
                <tr>
                  <td>500</td>
                  <td>18</td>
                </tr>
                <tr>
                  <td>500</td>
                  <td>19</td>
                </tr>
                <tr>
                  <td>500</td>
                  <td>20</td>
                </tr>
                <tr>
                  <td>500</td>
                  <td>21</td>
                </tr>
                <tr>
                  <td>200</td>
                  <td>22</td>
                </tr>
                <tr>
                  <td>200</td>
                  <td>23</td>
                </tr>
                <tr>
                  <td>200</td>
                  <td>24</td>
                </tr>
                <tr>
                  <td>200</td>
                  <td>25</td>
                </tr>
                <tr>
                  <td>200</td>
                  <td>26</td>
                </tr>
                <tr>
                  <td>200</td>
                  <td>27</td>
                </tr>
                <tr>
                  <td>200</td>
                  <td>28</td>
                </tr>
                <tr>
                  <td>200</td>
                  <td>29</td>
                </tr>
                <tr>
                  <td>200</td>
                  <td>30</td>
                </tr>
                <tr>
                  <td>200</td>
                  <td>31</td>
                </tr>
            
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
export default PrizeRule;
